import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { VehiclePreloader } from 'site-modules/shared/utils/core-page/vehicle-preloader-v2';
import { ConsumerReviewsModel, ConsumerReviewsPaths } from 'client/data/models/consumer-reviews';
import { UpdateReview } from './update-review';

export const pageOptions = {
  name: 'model_update_consumer_review',
  category: 'model_core',
  component: props => {
    const { params } = props.match;
    return <UpdateReview {...props} vehicleParams={params} reviewId={params.reviewId} />;
  },
  preload: (store, props) => {
    const { params } = props.match;
    const preloader = new VehiclePreloader(store, { ...props, params });

    preloader.set(ConsumerReviewsPaths.getVehicleFilterPath(), ConsumerReviewsModel, { params });
    preloader.set(ConsumerReviewsPaths.getCreateAndUpdateReviewIdPath(), ConsumerReviewsModel, params.reviewId);

    preloader.resolve(ConsumerReviewsPaths.buildReviewDataPath(params.reviewId), ConsumerReviewsModel);

    return preloader.load();
  },
  seo: {
    robots: {
      noIndex: true,
    },
  },
  options: {
    hasVehicleContext: true,
  },
};

export default pageDefinition(pageOptions);
